import React from "react";
import { Icon } from "__ICON_REFERENCE__";
import { withLocalizer } from "utilities/withLocalizer";
import { CONFIGURATION } from "utilities/configuration";

function PreviousButton(props) {
    let { data, events } = props;
    let { currentStep, isEdit, isAdd, isCloneEdited, isClone } = data;

    if (currentStep === 1 || currentStep > (CONFIGURATION.QUOTE_WIZARD_TOTAL_STEPS - 1)) return;

    return (
        <div className="wizard-button pull-left">
            <div className="next-link-button visible font-bold font-16 outline-button button-1x"
                onClick={
                    (currentStep === 2 && (isAdd || (isClone && !isCloneEdited))) ? events?.cancel : events?.previous}
            >
                <Icon name="arrow-left" className="arrow-l" />{props.localize("qma-navigation-back")}
            </div>
        </div >
    );
}

export default withLocalizer(PreviousButton);